import React from 'react';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';

export class MobileDrawerHeader extends React.Component {
	render() {
		const { header, isMobile } = this.props;
		return (
			<React.Fragment>
				{isMobile() && (
					<React.Fragment>
						<div className="drawer-fixed-header">{header}</div>
						<div style={{ paddingTop: '10px' }}>&nbsp;</div>
					</React.Fragment>
				)}
			</React.Fragment>
		);
	}
}

export default withIsMobile(MobileDrawerHeader);
